import { render, staticRenderFns } from "./B2cCouponsComponent.vue?vue&type=template&id=1146ec8c"
import script from "./B2cCouponsComponent.vue?vue&type=script&lang=js"
export * from "./B2cCouponsComponent.vue?vue&type=script&lang=js"
import style0 from "./B2cCouponsComponent.vue?vue&type=style&index=0&id=1146ec8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports